import { Action } from 'redux';

import { CreateExtracts } from '../../bootstrap/redux/actions/AppActionTypes';
import { ExtractEncryptionState } from '../../datasource/models/IDataSourceInfo';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface CreateExtractsAction extends Action {
  selectedContent: IContentInfo[];
  encryptionState: ExtractEncryptionState;
}

export function createExtractsMethod(
  selectedContent: IContentInfo[],
  encryptionState: ExtractEncryptionState
): CreateExtractsAction {
  return {
    type: CreateExtracts,
    selectedContent,
    encryptionState
  };
}
